"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_ADDRESS_HEADING_COPY = exports.CLERK_TEST_CODE = void 0;
exports.clerkTestAddressHint = clerkTestAddressHint;
/** Clerk's fixed verification code for `+clerk_test` addresses on a development instance. */
exports.CLERK_TEST_CODE = "424242";
/**
 * What an emailed-code screen should say for an address Clerk never emails (X2, BEN-141).
 * Shared by web and mobile: both import it from @fomofi/shared.
 *
 * On a Clerk DEVELOPMENT instance (publishable key `pk_test_…`), an address whose
 * local part contains `+clerk_test` gets no email at all and always accepts 424242.
 * Prod and dev both authenticate against such an instance today, so every test login
 * -- every reviewer's -- was told "Check your email" and then waited for an email that
 * never comes. On a production instance neither holds and a real email is sent, which
 * is why the key is part of the test, not just the address. Returns null for everyone
 * else, who keep the screen's own sentence.
 */
function clerkTestAddressHint(email, publishableKey) {
    if (!email || !publishableKey?.startsWith("pk_test_"))
        return null;
    const at = email.lastIndexOf("@");
    const local = at > 0 ? email.slice(0, at) : "";
    if (!/\+clerk_test/i.test(local))
        return null;
    // Named `…Copy` so scripts/copy-inventory.mjs lists the sentence for review.
    const testAddressCopy = `${email} is a test address, so no email is sent. Enter the test code ${exports.CLERK_TEST_CODE}.`;
    return testAddressCopy;
}
/** The heading a code screen shows when the hint applies. */
exports.TEST_ADDRESS_HEADING_COPY = "Enter your verification code";
//# sourceMappingURL=clerkTestAddress.js.map